<template>
  <b-row>
    <b-col cols="12" lg="9">
      <b-row>
        <b-col cols="12">
          <b-card v-if="isPCCEnded && pcc.video.length">
            <b-carousel
              id="carousel-1"
              :interval="4000"
              v-model="slide"
              indicators
              background="#ababab"
              img-width="1024"
              img-height="480"
              style="text-shadow: 1px 1px 2px #333;"
            >
              <b-carousel-slide v-for="vid in pcc.video" :key="vid.uuid">
                <template #img>
                  <video
                    controls
                    preload="auto"
                    class="w-100"
                    :src="vid.url"
                  ></video>
                </template>
              </b-carousel-slide>
            </b-carousel>
            <p v-if="pcc.video.length > 1" class="text-center mt-1 mb-0 pb-0">Video #{{slide+1}} <br>
            <small>To switch video, please select the indicators button above</small></p>
          </b-card>
        </b-col>
        <b-col cols="12">
          <b-card
            :img-src="pcc.banner_image_url"
            :title="pcc.title"
            img-width="auto"
          >
            <div
              class="mb-1"
              v-for="category in pcc.pcc_categories"
              :key="category.id"
            >
              <b-badge variant="light-primary">{{ category.name }}</b-badge>
            </div>
            <div v-html="pcc.description" />
            
            <div class="mt-2" v-if="pcc.link">
              <template v-if="!isJoined">
                <div class="d-flex">
                  <feather-icon style="color:#a71e20" size="17" icon="LockIcon"></feather-icon>
                  <h6 class="ml-50">
                    Link Conference
                  </h6>
                </div>

                <div>
                  <p>
                    To access the link. You must join the event first
                  </p>
                </div>
              </template>
              <template v-else>
                <div class="d-flex">
                  <feather-icon style="color:#e83e8c" size="17" icon="ExternalLinkIcon"></feather-icon>
                  <h6 class="ml-50">
                    Link Conference :
                  </h6>
                </div>
                <div>
                  <p>
                    <b-link target="_blank" :href="pcc.link" style="color:blue">{{pcc.link}}</b-link>
                  </p>
                </div>
              </template>
            </div>

            <template #footer>
              <div class="d-flex justify-content-end">
                <b-link v-tracker="'button:share-pcc'" @click="copyLink">
                  <feather-icon icon="Share2Icon" />
                  <span class="ml-25">Share</span>
                </b-link>
              </div>
            </template>
          </b-card>
        </b-col>
        <b-col>
          <b-card title="Document" v-if="isJoined">
            <template v-if="isJoined && isRated">
              <div
                v-for="attachment in pcc.attachments"
                :key="attachment.id"
                class="border mb-1 rounded d-flex align-items-center justify-content-between border-primary p-1"
              >
                <div>
                  <feather-icon size="16" icon="FileTextIcon" />
                  <span class="ml-1">{{ attachment.file }}</span>
                </div>
                <b-button
                  type="button"
                  class="txt-xs-2"
                  size="sm"
                  variant="primary"
                  @click="downloadAttachment(attachment.id)"
                >
                  <feather-icon size="14" icon="DownloadIcon" /> Download
                </b-button>
              </div>
            </template>
            <template v-else>
              <div class="d-flex">
                <feather-icon size="20" icon="LockIcon"></feather-icon>
                <h4 class="ml-50">
                  Access Denied
                </h4>
              </div>

              <div>
                <p>
                  To access the documents. You must meet the following
                  requirements
                </p>
                <div>
                  <div class="d-flex align-items-center mb-50">
                    <span :class="{ 'text-success': isJoined }">
                      <feather-icon
                        size="18"
                        :icon="isJoined ? 'CheckSquareIcon' : 'SquareIcon'"
                      />
                    </span>
                    <span class="ml-25">Join the PCC</span>
                  </div>
                  <div class="d-flex align-items-center">
                    <span :class="{ 'text-success': isRated }">
                      <feather-icon
                        size="18"
                        :icon="isRated ? 'CheckSquareIcon' : 'SquareIcon'"
                      />
                    </span>
                    <span class="ml-25">
                      Rate the PCC.
                      <b-link
                        class="underline italic"
                        v-b-modal.rating-pcc-modal
                      >
                        Click here for Rating
                      </b-link>
                    </span>
                  </div>
                </div>
              </div>
              <b-modal
                body-class="p-0"
                hide-footer
                id="rating-pcc-modal"
                size="lg"
                hide-header
                :hide-header-close="false"
              >
                <rating-pcc :pccId="pcc.id" @submitted="ratingSubmited" />
              </b-modal>
            </template>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
    <b-col cols="12" lg="3">
      <b-row>
        <b-col cols="12">
          <b-card no-body class="card-developer-meetup">
            <b-card-body class="p-1">
              <!-- header -->
              <div class="meetup-header d-flex align-items-center">
                <div class="meetup-day">
                  <h6 class="mb-0 text-uppercase">
                    {{ $moment(pcc.start_datetime).format('ddd') }}
                  </h6>
                  <h3 class="mb-0">
                    {{ $moment(pcc.start_datetime).format('Do') }}
                  </h3>
                </div>
                <div class="my-auto">
                  <b-card-title class="mb-25">
                    {{ pcc.title }}
                  </b-card-title>
                </div>
              </div>
              <!-- end header -->

              <!-- speaker -->
              <b-media no-body>
                <b-media-aside class="mr-1">
                  <b-avatar rounded variant="light-primary" size="34">
                    <feather-icon icon="MicIcon" size="18" />
                  </b-avatar>
                </b-media-aside>
                <b-media-body>
                  <div
                    class="mb-25"
                    v-for="speaker in pcc.speakers"
                    :key="speaker.id"
                  >
                    <h6 class="mb-0">
                      {{ speaker.speaker }}
                    </h6>
                    <small>{{ speaker.position }}</small>
                  </div>
                </b-media-body>
              </b-media>
              <!-- end speaker -->

              <!-- date -->
              <b-media no-body>
                <b-media-aside class="mr-1">
                  <b-avatar rounded variant="light-primary" size="34">
                    <feather-icon icon="CalendarIcon" size="18" />
                  </b-avatar>
                </b-media-aside>
                <b-media-body>
                  <h6 class="mb-0">
                    {{
                      $moment(pcc.start_datetime).format('ddd, Do MMMM YYYY')
                    }}
                  </h6>
                  <small>
                    {{ 
                      isPCCEnded ? 'ENDED' : pcc.is_open ? 
                            `Open at : ${this.$moment(
                              this.pcc.start_datetime
                            ).locale('en').format('D MMM YYYY, h:mm A')}`
                            : 'CLOSED'
                    }}
                  </small>
                </b-media-body>
              </b-media>
              <!-- end date -->

              <!-- address -->
              <b-media no-body>
                <b-media-aside class="mr-1">
                  <b-avatar rounded variant="light-primary" size="34">
                    <feather-icon icon="MapPinIcon" size="18" />
                  </b-avatar>
                </b-media-aside>
                <b-media-body style="word-break: break-word;" v-html="pcc.address" />
              </b-media>
              <!-- end address -->

              <template vi> </template>
              <b-button
                :disabled="isJoined || !isOpen || isPCCEnded"
                class="mt-1"
                block
                :variant="joinVariantClass()"
                @click="joinPCC()"
              >
                {{ joinText() }}
              </b-button>
            </b-card-body>
          </b-card>
        </b-col>

        <b-col cols="12">
          <b-card title="Who Just Joined">
            <div
              class="d-flex align-items-center mb-1"
              v-for="participant in pcc.participants"
              :key="participant.id"
            >
              <b-avatar class="mr-1" :src="`https://pwb.telkom.co.id/index.php?r=pwbPhoto/profilePhoto&nik=`+participant.user.USERNAME" />
              <div>{{ participant.user.NAME ? participant.user.NAME : participant.user.USERNAME }}</div>
            </div>

            <div class="d-flex justify-content-end">
              <p class="text-muted mb-0">
                {{ `${pcc.participants_count} Participants` }}
              </p>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import {
  BCarousel,
  BCarouselSlide,
  BRow,
  BCol,
  BCard,
  BBadge,
  BLink,
  BCardBody,
  BCardTitle,
  BMedia,
  BMediaAside,
  BAvatar,
  BListGroup,
  BListGroupItem,
  BButton,
  BFormCheckboxGroup,
  BFormCheckbox,
  BMediaBody,
  BModal,
  VBModal,
} from 'bootstrap-vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import RatingPcc from '@/views/user/pcc/RatingPCC.vue'

export default {
  components: {
    BCarousel,
    BCarouselSlide,
    BRow,
    BCol,
    BCard,
    BBadge,
    BLink,
    FeatherIcon,
    BCardBody,
    BCardTitle,
    BMedia,
    BMediaAside,
    BAvatar,
    BListGroup,
    BListGroupItem,
    BButton,
    BFormCheckboxGroup,
    BFormCheckbox,
    BMediaBody,
    ToastificationContent,
    BModal,
    RatingPcc,
  },

  directives: {
    VBModal,
  },

  mounted() {
    this.fetchDetailPCC()
  },

  data() {
    return {
      pcc: {
        category: '',
        attachments: [],
        speakers: [],
        pcc_products: [],
        start_datetime: '',
        end_datetime: '',
        is_open: false,
        video: {
          file: '',
          url: '',
        },
      },
      slide: 0,
      isJoined: false,
      isRated: false,
    }
  },

  computed: {
    isPCCEnded: function() {
      return this.$moment().isAfter(this.$moment(this.pcc.end_datetime))
    },
    isStarted: function() {
      return this.$moment(this.pcc.start_datetime).isSame(new Date(), 'day')
    },
    isOpen: function() {
      return this.pcc.is_open
    },
  },

  methods: {
    fetchDetailPCC() {
      this.$http
        .get(`/pcc/detail/${this.$route.params.id}`)
        .then(({ data }) => {
          this.pcc = data.data
          this.isJoined = data.is_joined
          this.isRated = data.is_rated
        })
        .catch(err => {
          this.$router.push({ name: 'list-pcc' })
          this.$notif('Error', `${err.message}`, 'error')
        })
    },

    downloadAttachment(attachmentId) {
      return window.open(
        `${process.env.VUE_APP_API_HOST}/api/pcc/download/${attachmentId}`
      )
    },

    joinPCC() {
      this.$http
        .post(`/pcc/join/${this.pcc.id}`)
        .then(() => {
          this.$notif(
            'Success',
            `You have been successfully joined ${this.pcc.title}`,
            'success'
          )
          this.fetchDetailPCC()
        })
        .catch(err => {
          this.$notif('Error', `${err.message}`, 'error')
        })
    },

    copyLink() {
      this.$copyText(window.location.host + this.$route.fullPath).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Link copied',
            icon: 'BellIcon',
          },
        })
      })
    },

    ratingSubmited() {
      this.$bvModal.hide('rating-pcc-modal')
      this.fetchDetailPCC()
    },

    joinText() {
      if (this.isJoined) {
        return 'You have joined'
      }

      if (this.isPCCEnded) {
        return 'Event ended'
      }

      if (this.isOpen) {

        return 'Join event'
      }

      return `Open at : ${this.$moment(this.pcc.start_datetime).locale('en').format(
        'D MMM YYYY, HH:mm A'
      )}`
    },

    joinVariantClass() {
      if (this.isJoined) {
        return 'success'
      }

      if (this.isOpen) {
        if (this.isPCCEnded) {
          return 'light'
        }
        return 'primary'
      }

      return 'light'
    },
  },
}
</script>

<style scoped>
.card-img {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
  object-fit: contain;
}

.underline {
  text-decoration: underline;
}

.italic {
  font-style: italic;
}
</style>
